import { config } from 'devextreme/common';

config({
    licenseKey: 'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjNiNDEwNzg1LTVjNGQtNDQwYy04M2ExLTdkNTZiYjI0ZDQyNSIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUyCn0=.PsK+vlpCcbztlUPrU0hB6SsC7/gz+0heGofSpZnU+KbmQ2P+sh4H2COi84AGU0BfoQZCKzHFdnTVo/lh74YhaABWHJ4/dpzPUAm6vbDc4jkrld3vY/ZZs5FUdPFQY/D6c92JGw=='
});
